import React from "react";

const SystemLogs = () => {
  return <div>Audit trail will be shown here</div>;
};

export default SystemLogs;

// import { Button } from "antd";
// import { LucideUpload, Search } from "lucide-react";
// import {
//   downloadAuditTrail,
//   downloadSelectedAuditTrail,
//   getAuditTrail,
// } from "../../sdk/trail/trail";
// import { useEffect, useState } from "react";
// import Trail from "../../components/audit-trail/Trail";
// import Loading from "../../shared/Loading";
// import { downloadExportFile } from "../../helpers/export";
// import Calendar from "../../components/calendar/Calendar";
// import { AuditTrailRowSkeleton } from "../../skeletons/MySkeleton";

// const SystemLogs = () => {
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalItems, setTotalItems] = useState(0);
//   const [limit, setLimit] = useState(25);
//   const [fromDate, setFromDate] = useState(new Date("2023-11-23"));
//   const [toDate, setToDate] = useState(new Date());
//   const [auditTrails, setAuditTrails] = useState([]);
//   const [search, setSearch] = useState("");
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [myLoading, setMyLoading] = useState(false);
//   const [openAuditTrail, setOpenAuditTrail] = useState(false);
//   const [selectedTrail, setSelectedTrail] = useState({});
//   const [focusedInput, setFocusedInput] = useState(null);

//   // Toggle a single checkbox
//   const toggleSelect = (id) => {
//     setSelectedIds((prev) =>
//       prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
//     );
//   };

//   // Toggle all checkboxes
//   const toggleSelectAll = () => {
//     if (selectedIds.length === auditTrails.length) {
//       setSelectedIds([]);
//     } else {
//       setSelectedIds(auditTrails.map((log) => log.id));
//     }
//   };

//   const handleLimitChange = (e) => {
//     const newItemsPerPage = Number(e.target.value);
//     setLimit(newItemsPerPage);
//     setPage(1);
//   };

//   const renderPages = () => {
//     const pages = [];
//     for (let i = 1; i <= Math.min(totalPages, 3); i++) {
//       pages.push(
//         <div
//           key={i}
//           className={`w-[36px] cursor-pointer h-[36px] rounded-[10px] flex items-center justify-center ${
//             page === i
//               ? "bg-[#005C53] text-white"
//               : "bg-[#F5F5F5] text-[#005C53]"
//           }`}
//           onClick={() => handlePageChange(i)}
//         >
//           <p>{i}</p>
//         </div>,
//       );
//     }

//     return pages;
//   };

//   const toggleAuditTrail = (log) => {
//     setSelectedTrail(log);
//     setOpenAuditTrail(true);
//   };
//   const closeAuditTrail = () => {
//     setOpenAuditTrail(false);
//   };

//   const handlePageChange = (page) => {
//     setPage(page);
//   };

//   const fetchAuditTrails = async () => {
//     setLoading(true);
//     try {
//       const response = await getAuditTrail(
//         page,
//         limit,
//         fromDate ? fromDate.toISOString() : null,
//         toDate ? toDate.toISOString() : null,
//       );
//       if (response.status === 200) {
//         setAuditTrails(response?.data.rows);
//         setPage(response?.data.page);
//         setLimit(response?.data.limit);
//         setTotalPages(response?.data.totalPages);
//         setTotalItems(response?.data?.total);
//         setLoading(false);
//       } else {
//         setLoading(false);
//       }
//     } catch (error) {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAuditTrails();
//   }, [page, limit, fromDate, toDate]);

//   const downloadAllAuditTrails = async () => {
//     setIsLoading(true);
//     try {
//       const response = await downloadAuditTrail(
//         page,
//         limit,
//         fromDate ? fromDate.toISOString() : null,
//         toDate ? toDate.toISOString() : null,
//         search,
//         "csv",
//       );
//       if (response.status === 200 || response.status === 201) {
//         downloadExportFile(response.data, `audit-trail.csv`);
//         setIsLoading(false);
//       } else {
//         setIsLoading(false);
//       }
//     } catch (error) {
//       setIsLoading(false);
//     }
//   };

//   const downloadSelectedAuditTrails = async () => {
//     setMyLoading(true);
//     try {
//       const response = await downloadSelectedAuditTrail(selectedIds, "csv");
//       if (response.status === 200 || response.status === 201) {
//         downloadExportFile(response.data, `audit-trail.csv`);
//         setMyLoading(false);
//       } else {
//         setMyLoading(false);
//       }
//     } catch (error) {
//       setMyLoading(false);
//     }
//   };

//   function deriveActionDescription(method, route) {
//     // Clean the route and extract meaningful parts
//     const cleanRoute = route.replace(/^\/api\/v\d+\//, "").replace(/-/g, " ");
//     const parts = cleanRoute.split("/").filter(Boolean); // Split into parts

//     // Join meaningful parts into a phrase
//     const resource = parts.join(" ");

//     // Map HTTP method to an action verb
//     const methodActionMap = {
//       GET: "View",
//       POST: "Create",
//       PUT: "Update",
//       PATCH: "Modify",
//       DELETE: "Delete",
//     };

//     const actionVerb = methodActionMap[method.toUpperCase()] || method;

//     // Return the final description
//     return `${actionVerb} ${resource}`;
//   }

//   function deriveModuleFromRoute(route) {
//     // Remove '/api/' prefix and optional version like 'v1/', 'v2/', etc.
//     const cleanRoute = route.replace(/^\/api\/(v\d+\/)?/, "");

//     // Split by '/' and take the first part
//     const [firstSegment] = cleanRoute?.split("/").filter(Boolean);

//     // Replace dashes with spaces and return as module name
//     return firstSegment ? firstSegment.replace(/-/g, " ") : "unknown";
//   }

//   return (
//     <>
//       {openAuditTrail && (
//         <Trail closeAuditTrail={closeAuditTrail} auditData={selectedTrail} />
//       )}
//       <div className="w-full mb-[10px] pl-[10px]">
//         <p className="font-bold text-[24px] text-[#222222]">System Logs</p>
//         <div className="w-full p-[10px]">
//           <div className="flex items-center mb-[10px] border border-gray-300 rounded-md px-2 h-[40px] w-[50%] bg-white">
//             <Search className="text-gray-500 w-5 h-5 mr-2" />
//             <input
//               type="text"
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search logs, users..."
//               className="w-full outline-none text-sm text-gray-700 placeholder-gray-400 bg-transparent"
//             />
//             <button
//               onClick={fetchAuditTrails}
//               className="ml-2 p-2 bg-blue-600 rounded-md hover:bg-blue-700"
//             >
//               <Search className="w-4 h-4 text-white" />
//             </button>
//           </div>
//           <div className="h-[63px] mb-[10px] w-full bg-[#F7FFD7] flex items-center justify-between px-[10px]">
//             <div className="flex items-center gap-[20px]">
//               <div className="h-[40px] w-[117px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-white flex items-center justify-center">
//                 {selectedIds?.length} Selected
//               </div>
//               <Calendar
//                 startDate={fromDate}
//                 endDate={toDate}
//                 setStartDate={setFromDate}
//                 setEndDate={setToDate}
//                 focusedInput={focusedInput}
//                 setFocusedInput={setFocusedInput}
//               />
//               <p className="text-[#005C53] truncate text-[15px] font-normal">
//                 {auditTrails?.length} Results
//               </p>
//             </div>
//             <div className="flex items-center gap-[20px]">
//               <button
//                 className="block text-white bg-[#005C53] focus:outline-none focus:ring-[#005C53] rounded-[3px] text-center w-[10vw] h-[40px]"
//                 type="button"
//                 onClick={fetchAuditTrails}
//               >
//                 <div className="flex items-center justify-center gap-2">
//                   {!loading && (
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="29"
//                       height="29"
//                       viewBox="0 0 29 29"
//                       fill="none"
//                     >
//                       <path
//                         d="M14.5931 22.9583C12.232 22.9583 10.2318 22.1395 8.59252 20.5018C6.95402 18.8633 6.13477 16.8639 6.13477 14.5036C6.13477 12.1433 6.95402 10.1431 8.59252 8.50303C10.2318 6.86211 12.232 6.04166 14.5931 6.04166C16.0294 6.04166 17.3739 6.38281 18.6265 7.06511C19.88 7.74742 20.8901 8.69999 21.657 9.92282V6.04166H22.8653V12.3612H16.5458V11.1529H21.0166C20.3875 9.9486 19.5022 8.99684 18.3607 8.29761C17.2208 7.5992 15.965 7.24999 14.5931 7.24999C12.5792 7.24999 10.8674 7.95485 9.45768 9.36457C8.04796 10.7743 7.3431 12.4861 7.3431 14.5C7.3431 16.5139 8.04796 18.2257 9.45768 19.6354C10.8674 21.0451 12.5792 21.75 14.5931 21.75C16.1438 21.75 17.5434 21.3069 18.7921 20.4208C20.0407 19.5347 20.9167 18.3667 21.4202 16.9167H22.7022C22.1698 18.7259 21.1576 20.1852 19.6657 21.2944C18.1738 22.4037 16.4829 22.9583 14.5931 22.9583Z"
//                         fill="white"
//                       />
//                     </svg>
//                   )}
//                   {loading && (
//                     <svg
//                       aria-hidden="true"
//                       className="w-[20px] h-[20px] text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
//                       viewBox="0 0 100 101"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//                         fill="currentColor"
//                       />
//                       <path
//                         d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//                         fill="currentFill"
//                       />
//                     </svg>
//                   )}
//                   <p className="text-[#FFF] font-normal text-[16px]">REFRESH</p>
//                 </div>
//               </button>
//               {selectedIds?.length > 0 ? (
//                 <Button
//                   disabled={myLoading}
//                   onClick={downloadSelectedAuditTrails}
//                   className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]"
//                 >
//                   {myLoading ? <Loading /> : <LucideUpload size={17} />}
//                   <span>Export</span>
//                 </Button>
//               ) : (
//                 <Button
//                   disabled={isLoading}
//                   onClick={downloadAllAuditTrails}
//                   className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]"
//                 >
//                   {isLoading ? <Loading /> : <LucideUpload size={17} />}
//                   <span>Export</span>
//                 </Button>
//               )}
//             </div>
//           </div>
//           <div className="w-full h-[40px] mb-[7px] text-[13px] px-[10px] bg-[#F0FFFE] flex items-center">
//             <div className="w-[5%] text-[#000000] font-bold">
//               <input
//                 type="checkbox"
//                 checked={selectedIds.length === auditTrails.length}
//                 onChange={toggleSelectAll}
//               />
//             </div>
//             <div className="w-[10%] text-[#000000] font-bold">ID</div>
//             <div className="w-[10%] text-[#000000] font-bold">
//               ACTION CATEGORY
//             </div>
//             <div className="w-[17%] text-[#000000] font-bold">
//               ACTION DESCRIPTION
//             </div>
//             <div className="w-[11.4%] text-[#000000] font-bold">
//               ENTITY AFFECTED
//             </div>
//             <div className="w-[11.5%] text-[#000000] font-bold">USERS</div>
//             <div className="w-[25%] text-[#000000] font-bold">USER AGENT</div>
//             <div className="w-[10%] text-[#000000] font-bold">DATE/TIME</div>
//           </div>
//           <div>
//             {loading &&
//               Array?.from({ length: 6 }).map((_, index) => (
//                 <AuditTrailRowSkeleton key={index} />
//               ))}
//             {!loading &&
//               auditTrails &&
//               auditTrails?.map((log) => (
//                 <div className="w-full h-[37px] text-[14px] px-[10px] mb-[7px] bg-[#ffffff] flex items-center">
//                   <div className="w-[5%] truncate text-[#000000] font-normal">
//                     <input
//                       type="checkbox"
//                       checked={selectedIds.includes(log.id)}
//                       onChange={() => toggleSelect(log.id)}
//                     />
//                   </div>
//                   <div
//                     onClick={() => toggleAuditTrail(log)}
//                     className="w-[10%] truncate text-[#037BD1] cursor-pointer font-normal"
//                   >
//                     {`AT-${log?.id?.slice(0, 8)}`}
//                   </div>
//                   <div className="w-[10%] truncate text-[#000000] font-normal">
//                     {deriveModuleFromRoute(log?.route)}
//                   </div>
//                   <div className="w-[17%] truncate text-[#000000] font-normal">
//                     {deriveActionDescription(log?.method, log?.route)}
//                   </div>
//                   <div className="w-[11.5%] truncate text-[#000000] font-normal">
//                     {log?.route}
//                   </div>
//                   <div className="w-[11.5%] truncate text-[#000000] font-normal">
//                     {log?.userId ?? "N/A"}
//                   </div>
//                   <div className="w-[25%] truncate text-[#000000] font-normal">
//                     {`${log?.userAgent} - ${log?.ip}`}
//                   </div>
//                   <div className="w-[10%] truncate text-[#000000] font-normal">
//                     {new Date(log?.createdAt).toISOString().split("T")[0]}
//                   </div>
//                 </div>
//               ))}
//             {!loading && auditTrails?.length === 0 && (
//               <p className="text-center text-gray-400 mt-4">
//                 No audit trails found
//               </p>
//             )}
//           </div>
//           <div className="h-[70px] bg-white w-[97%] px-[20px] mx-auto mb-[20px] flex items-center justify-between">
//             <div className="flex items-center gap-[20px]">
//               <p className="text-[#005C53] !text-[14px]">Rows per Page</p>
//               <select
//                 name="page"
//                 id="page"
//                 className="w-[71px] border-[1px] px-[5px] h-[30px] focus:outline-none"
//                 value={limit}
//                 onChange={handleLimitChange}
//               >
//                 <option value="50">50</option>
//                 <option value="30">30</option>
//                 <option value="25">25</option>
//                 <option value="10">10</option>
//               </select>
//               <p className="text-[#005C53] text-[14px]">
//                 {page} / {totalPages} ({totalItems} records)
//               </p>
//             </div>
//             <div className="flex items-center gap-[15px]">
//               <p
//                 onClick={() => handlePageChange(Math.max(page - 1, 1))}
//                 className="text-[14px] cursor-pointer text-[#005C53]"
//               >
//                 Prev
//               </p>
//               {renderPages()}
//               <div
//                 className={`w-[36px] cursor-pointer h-[36px] rounded-[10px] flex items-center justify-center ${
//                   Number(page) > 3
//                     ? "bg-[#005C53] text-white"
//                     : "bg-[#F5F5F5] text-[#005C53]"
//                 }`}
//               >
//                 <p>{Number(page) > 3 ? page : "..."}</p>
//               </div>
//               <p
//                 onClick={() => handlePageChange(Math.min(page + 1, totalPages))}
//                 className="text-[14px] cursor-pointer text-[#005C53]"
//               >
//                 Next
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SystemLogs;
